import classnames from 'classnames';
import React from 'react';
import useLayoutDirection from '../utils/Translations/useLayoutDirection';
import Button from './Button';
import ButtonDropdown from './ButtonDropdown';
import styles from './RoundedDropdownButton.scss';
function RoundedDropdownButton({ actions, disabled, additionClasses = '', isSubmitTogglesDropdown = false, dataCy, ...props }) {
    const { isLayoutRTL } = useLayoutDirection();
    const actionButton = (<Button additionClasses={classnames(additionClasses, styles.buttonActionStyle, {
        [styles.rtlButtonActionStyle]: isLayoutRTL,
    }, 'btn-rounded')} buttonStyle="primary" dataCy={dataCy ? `${dataCy}-button` : undefined} disabled={disabled} type="submit" {...props}/>);
    const dropdownButton = (<ButtonDropdown actions={actions} additionClasses={classnames(additionClasses, styles.buttonDropdownStyle, {
        [styles.rtlButtonDropdownStyle]: isLayoutRTL,
    }, 'btn-rounded')} dataCy={dataCy} disabled={disabled} isSubmitTogglesDropdown={isSubmitTogglesDropdown} {...props}/>);
    return (<div className={classnames('btn-group', styles.marginHeight)}>
      {!isSubmitTogglesDropdown && isLayoutRTL ? dropdownButton : null}
      {!isSubmitTogglesDropdown ? actionButton : null}
      {isSubmitTogglesDropdown || !isLayoutRTL ? dropdownButton : null}
    </div>);
}
export default RoundedDropdownButton;
